<template>
  <quillEditor :value="value" :options="options" @change="onEditorChange"/>
</template>

<script>
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import { quillEditor } from 'vue-quill-editor'

  export default {
    components: {quillEditor},
    data() {
      return {
        options: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
              // ['blockquote', 'code-block'],
              ['code-block'],

              // [{ 'header': 1 }, { 'header': 2 } ],               // custom button values
              [{'list': 'ordered'}, {'list': 'bullet'}],
              [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
              [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
              // [{ 'direction': 'rtl' }],                         // text direction

              [{'size': ['small', false, 'large']}],  // custom dropdown
              // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

              [{'color': []}, {'background': []}],          // dropdown with defaults from theme
              // [{ 'font': [] }],
              [{'align': []}],
              ['link', 'image', 'video'],

              ['clean']                                         // remove formatting button
            ]

          }
        }
      }
    },
    methods: {
      onEditorChange(value) {
        this.$emit('input', value.html)
      },
    },
    mounted() {
      let bold = document.querySelector('.ql-bold')
      bold.title = 'Negrito'
    },
    name: 'Editor',
    props: ['value']
  }
</script>

<style scoped>

  .ql-size span.ql-picker-label::before {
    content: 'Tamanho' !important
  }
</style>
